interface Tile {
  label: string;
  value: number | string;
}

/** Three at-a-glance audit tiles (PRD §7.1). */
export function SummaryTiles({ tiles }: { tiles: Tile[] }) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {tiles.map((t) => (
        <div key={t.label} className="rounded-lg border border-surface-border bg-surface p-4">
          <div className="text-meta text-text-muted">{t.label}</div>
          <div className="mt-1 text-title font-semibold text-text">{t.value}</div>
        </div>
      ))}
    </div>
  );
}
